import React, { Children, useState } from 'react';

import { PublicLayout } from '@/components/PublicLayout';
import { privacyPolicyLink, termsOfServiceLink } from '@/config/constants';
import { Helmet } from 'react-helmet';

export const Layout: React.FC<{
	header?: JSX.Element;
	logo?: JSX.Element;
	footer?: JSX.Element;
	title: string;
}> = ({ header, footer, logo, title, children }) => (
	<PublicLayout
		logo={logo}
		renderHeader={header}
		renderFooter={
			footer || (
				<div className="authentication-content__privacy-policy">
					By continuing you agree to our
					<br />
					<a
						className="authentication-content__privacy-policy__link"
						href={termsOfServiceLink}
						target="_blank"
						rel="noreferrer"
					>
						Terms of Service
					</a>
					{' and '}
					<a
						className="authentication-content__privacy-policy__link"
						href={privacyPolicyLink}
						target="_blank"
						rel="noreferrer"
					>
						Privacy Policy
					</a>
				</div>
			)
		}
	>
		<Helmet title={title} />
		{children}
	</PublicLayout>
);
